import type { CustomIconProps } from '../CustomIcon';

export const TrashClockIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      xmlns='http://www.w3.org/2000/svg'
      style={{ paddingTop: 2 }}
      {...props}>
      <g clipPath='url(#clip0_5730_21673)'>
        <path
          d='M13.2008 5.2056V13.9232C13.2008 14.2535 13.0696 14.5703 12.836 14.8038C12.6025 15.0374 12.2857 15.1686 11.9554 15.1686H5.72853C5.39824 15.1686 5.08147 15.0374 4.84792 14.8038C4.61436 14.5703 4.48315 14.2535 4.48315 13.9232V5.2056H13.2008ZM6.35122 5.2056V3.96022C6.35122 3.62993 6.48243 3.31316 6.71598 3.07961C6.94953 2.84605 7.2663 2.71484 7.59659 2.71484H10.0873C10.4176 2.71484 10.7344 2.84605 10.968 3.07961C11.2015 3.31316 11.3327 3.62993 11.3327 3.96022V5.2056'
          fill={ternaryColor}
        />
        <path
          d='M13.2008 5.2056H13.8258C13.8258 4.86042 13.546 4.5806 13.2008 4.5806V5.2056ZM4.48315 13.9232H3.85815H4.48315ZM4.48315 5.2056V4.5806C4.13798 4.5806 3.85815 4.86042 3.85815 5.2056H4.48315ZM5.72622 5.2056C5.72622 5.55077 6.00604 5.8306 6.35122 5.8306C6.6964 5.8306 6.97622 5.55077 6.97622 5.2056H5.72622ZM7.59659 2.71484V2.08984V2.71484ZM10.0873 2.71484V2.08984V2.71484ZM10.7077 5.2056C10.7077 5.55077 10.9875 5.8306 11.3327 5.8306C11.6779 5.8306 11.9577 5.55077 11.9577 5.2056H10.7077ZM12.5758 5.2056V13.9232H13.8258V5.2056H12.5758ZM12.5758 13.9232C12.5758 14.0878 12.5104 14.2456 12.3941 14.3619L13.278 15.2458C13.6287 14.895 13.8258 14.4193 13.8258 13.9232H12.5758ZM12.3941 14.3619C12.2777 14.4782 12.1199 14.5436 11.9554 14.5436V15.7936C12.4515 15.7936 12.9272 15.5965 13.278 15.2458L12.3941 14.3619ZM11.9554 14.5436H5.72853V15.7936H11.9554V14.5436ZM5.72853 14.5436C5.564 14.5436 5.4062 14.4782 5.28986 14.3619L4.40597 15.2458C4.75674 15.5965 5.23248 15.7936 5.72853 15.7936V14.5436ZM5.28986 14.3619C5.17352 14.2456 5.10815 14.0878 5.10815 13.9232H3.85815C3.85815 14.4193 4.05521 14.895 4.40597 15.2458L5.28986 14.3619ZM5.10815 13.9232V5.2056H3.85815V13.9232H5.10815ZM4.48315 5.8306H13.2008V4.5806H4.48315V5.8306ZM6.97622 5.2056V3.96022H5.72622V5.2056H6.97622ZM6.97622 3.96022C6.97622 3.79569 7.04158 3.63789 7.15792 3.52155L6.27404 2.63766C5.92328 2.98843 5.72622 3.46416 5.72622 3.96022H6.97622ZM7.15792 3.52155C7.27427 3.4052 7.43206 3.33984 7.59659 3.33984V2.08984C7.10054 2.08984 6.6248 2.2869 6.27404 2.63766L7.15792 3.52155ZM7.59659 3.33984H10.0873V2.08984H7.59659V3.33984ZM10.0873 3.33984C10.2519 3.33984 10.4097 3.4052 10.526 3.52155L11.4099 2.63766C11.0591 2.2869 10.5834 2.08984 10.0873 2.08984V3.33984ZM10.526 3.52155C10.6424 3.63789 10.7077 3.79569 10.7077 3.96022H11.9577C11.9577 3.46416 11.7607 2.98843 11.4099 2.63766L10.526 3.52155ZM10.7077 3.96022V5.2056H11.9577V3.96022H10.7077Z'
          fill={color}
        />
        <g clipPath='url(#clip1_5730_21673)'>
          <path
            d='M14.8675 18.3537C17.0613 18.3537 18.8397 16.5752 18.8397 14.3814C18.8397 12.1876 17.0613 10.4092 14.8675 10.4092C12.6737 10.4092 10.8953 12.1876 10.8953 14.3814C10.8953 16.5752 12.6737 18.3537 14.8675 18.3537Z'
            fill={color}
            stroke={secondaryColor}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.8677 12.2979V14.3812L16.2566 15.0756'
            stroke={secondaryColor}
            strokeWidth='0.833337'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <path
          d='M3.23779 5.20605H4.48317H14.4462'
          stroke={color}
          strokeWidth='1.25001'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5730_21673'>
          <rect
            width='20.0001'
            height='20.0001'
            fill='white'
            transform='translate(0.737793 0.214844)'
          />
        </clipPath>
        <clipPath id='clip1_5730_21673'>
          <rect width='10' height='10' fill='white' transform='translate(10.1064 9.74121)' />
        </clipPath>
      </defs>
    </svg>
  );
};
